export enum ECode {
  SUCCESS = 0,

  NOT_SUPPORT_VERSION = -101,
  NOT_GROUP_OWNER = -102,
  ALREADY_WAS_COMMUNITY = -103,
  INVALID_QUOTA = -104,

  //zba upgrade error
  ALREADY_ZBA = -200,
  HAS_BOT = -201,
  MIN_AGE_EXCEED = -300,
  NEW_ACCOUNT = -305,
  BLACK_USER = -306,
  INVALID_STATUS = -307,
  FAIL_FIELD44 = -308,
  USER_NOT_KYC = -309,
  CLONE_USER = -310,
  FOREIGN_PHONE = -311,
  NOT_ENOUGH_FRIEND = -312,

  SUBSCRIPTION_CONFLICT = -12092,

  EXCEPTION = -1001,
}
